module.exports = __webpack_public_path__ + "img/sun_grey.a522a35c.svg";